import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HttpService } from '../../service/http.service';

export const officeSubscriptionResolver: ResolveFn<Promise<any>> = async (route, state) => { 
  const hs = inject(HttpService);
  const {subscription} = (await hs.getOfficeSubscription() as any).data;
  return JSON.parse(subscription);
};
